/** Strings compartilhadas entre features (botões, ações genéricas, datas relativas). */
export const common = {
    actions: {
        cancel: 'Cancelar',
        save: 'Salvar',
        confirm: 'Confirmar',
        close: 'Fechar',
        back: 'Voltar',
        moreOptions: 'Mais opções',
        previousMonth: 'Mês anterior',
        nextMonth: 'Próximo mês',
        previousDay: 'Dia anterior',
        nextDay: 'Próximo dia',
        previousYear: 'Ano anterior',
        nextYear: 'Próximo ano',
    },
    relativeDate: {
        today: 'Hoje',
        yesterday: 'Ontem',
    },
    // Atalho aberto pelo rótulo do período no cabeçalho (Home, Transações, Análise).
    periodMenu: {
        open: 'Escolher período',
        current: 'Atual',
    },
    // Seletores nativos (galeria, câmera, arquivos) que não abrem — ver lib/mediaPicker.
    picker: {
        stuckTitle: 'O seletor não abriu',
        stuckBody: 'Feche o Kontto por completo (retire das tarefas recentes), abra de novo e tente mais uma vez.',
        noFileAppTitle: 'Não conseguimos abrir seus arquivos',
        noFileAppBody: 'Seu aparelho não tem um app de arquivos ativo para escolher o documento. Ative o app "Arquivos" nas configurações do Android (ou instale o Files, do Google) e tente de novo.',
        genericTitle: 'Não foi possível abrir o seletor',
        genericBody: 'Tente de novo. Se continuar, feche o Kontto por completo e abra outra vez.',
        fileMissingTitle: 'Não conseguimos abrir esse arquivo',
        fileMissingBody: 'Se ele está no iCloud, no Google Drive ou em outra nuvem, abra o app de arquivos e baixe o arquivo para o aparelho antes de escolher aqui.',
    },
    // Comprovante compartilhado de outro app que o Android não deixou ler —
    // ver lib/shareIntentError.
    shareIntent: {
        // Sem citar "Android": este toast também aparece no iOS (REACT-NATIVE-16),
        // onde dizer que o Android bloqueou o arquivo é simplesmente falso.
        failedTitle: 'Não conseguimos abrir o comprovante',
        failedBody: 'O sistema não liberou esse arquivo para o Kontto. Abra o app e use "Escanear comprovante" para importar direto da galeria.',
        // Caso diferente: o arquivo ABRIU, o tipo é que não serve.
        unsupportedTitle: 'Esse arquivo não serve como comprovante',
        unsupportedBody: 'O Kontto lê comprovante em imagem ou PDF. Para extrato em CSV ou OFX, abra o app e use Mais › Importar e exportar.',
    },
    link: {
        failedTitle: 'Não foi possível abrir o link',
        failedBody: 'Seu aparelho bloqueou a abertura do navegador. Você também encontra a página em kontto.com.br.',
    },
    logoSelector: {
        title: 'Logo do banco',
        automatic: 'Automático',
        detectedLogo: 'Logo detectada',
        noDetectedLogo: 'Sem logo detectada',
        groups: {
            brands: 'Bandeiras',
            banksBr: 'Bancos e carteiras',
            banksUs: 'Bancos dos EUA e internacionais',
            benefits: 'Vale e benefícios',
        },
    },
};
